import {Component, OnInit} from '@angular/core';
import {AgGridAngular} from "ag-grid-angular";
import {
  FormsModule,
  ReactiveFormsModule,
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators
} from "@angular/forms";
import { AsyncPipe } from "@angular/common";
import {ColDef, ColGroupDef, GridOptions, SizeColumnsToContentStrategy, SizeColumnsToFitGridStrategy, SizeColumnsToFitProvidedWidthStrategy} from "ag-grid-community";
import {takeWhile} from "rxjs/operators";
import {User} from 'src/app/services/user/user';
import {Router} from '@angular/router';
import AppConstants, * as Constants from '../../shared/common-components/AppConstants';
import {LoadingService} from "../../services/loading/loading.service";
import {HhgOnlineBookShipmentService} from "../hhg-online-book-shipment/hhg-online-book-shipment.service";
import {UserPreferencesService} from 'src/app/services/user-preferences/user-preferences.service';
import {ShipmentReviewService} from 'src/app/services/shipment-review/shipment-review.service';
import {AlertService} from "../../services/alert/alert.service";
import {UserService} from 'src/app/services/user/user.service';
import {BehaviorSubject} from 'rxjs';
import {DatePipe} from '@angular/common';
import _ from 'lodash';

@Component({
    selector: 'app-frt-tsp-rating-reports',
    imports: [
    AgGridAngular,
    FormsModule,
    ReactiveFormsModule
],
    templateUrl: './frt-shipment-pod-reports.component.html',
    styleUrl: './frt-shipment-pod-reports.component.css'
})
export class FrtShipmentPodReportsComponent implements OnInit{
  frtShipmentPodFormGroup: UntypedFormGroup;
  shipmentReviewList: any = [];
  shipmentReviewListBeforeEditFields: any = [];
  currentYear: any = 0;
  currentUser: User;
  years = [];
  onTimeReports: any;
  gridOptions: GridOptions = this.initializeGridOptions();
  private gridApi;
  columnDefs: any;
  public overlayNoRowsTemplate;
  rowData: any;
  grid: GridOptions;
  columnsDefs: any;
  orgId: number;
  carrierUser: boolean;
  carrierId: number;
  private observer$ = new BehaviorSubject(true);
  agency_admin = Constants.agency_admin_role;
  agency_user = Constants.agency_user;
  agency_auditor_role = Constants.agency_auditor_role;
  screenName: any;
  statuses: string[] = ['Accepted', 'Accepted with Qualification', 'Booked', 'Cancelled', 'Complete', 'Expired', 'Incomplete', 'Modified',
    'Pending', 'Refused'];
  statusesTsp: string[] = ['Accepted', 'Accepted with Qualification', 'Booked', 'Cancelled', 'Complete', 'Expired', 'Modified',
    'Pending', 'Refused'];
  recent: boolean;

  frtShipmentPodColumnDefs: (ColDef | ColGroupDef)[] = [
    <ColDef>
    <ColDef>
        {
          headerName: 'Shipment ID',
          field: 'shipmentId',
          filter: 'agNumberColumnFilter',
          width: 100,
          cellRenderer: params => {
            if (null != params.data.bolNumber || params.data.bolNumber || this.checkUserRole(this.agency_auditor_role)) {
              return params.data.shipmentId;
            }
            return '<a tabindex="0">' + params.data.shipmentId + '</a>';
          },
          onCellClicked: event => !this.checkUserRole(this.agency_auditor_role) ? this.onShipmentIdClicked(event.data) : null

        },
      {
        headerName: 'BOL Number',
        field: 'bolNumber',
        width: 100,
        filter: 'agTextColumnFilter',
        cellRenderer: params => {
          if ((null != params.data.bolNumber || params.data.bolNumber) && !this.checkUserRole(this.agency_auditor_role)) {
            return '<a tabindex="0">' + params.data.bolNumber + '</a>';
          }
          return params.data.bolNumber;
        },
        onCellClicked: event => !this.checkUserRole(this.agency_auditor_role) ? this.onShipmentIdClicked(event.data) : null
      },
      {
        headerName: 'TSP',
        field: 'carrierName',
        width: 250,
        filter: 'agTextColumnFilter'
      },
      {
        headerName: 'Agency-Bureau Name',
        field: 'agencyBureauName',
        filter: 'agTextColumnFilter',
        width: 100
      },
      {
        headerName: 'Origin',
        field: 'origin',
        width: 250,
        filter: 'agTextColumnFilter'
      },
      {
        headerName: 'Destination',
        field: 'destination',
        width: 250,
        filter: 'agTextColumnFilter'
      },
      {
        headerName: 'Status',
        width: 130,
        field: 'bookingStatus',
        filter: 'agTextColumnFilter'
      },
      {
        headerName: 'Total Cost',
        width: 90,
        field: 'totalCost',
        filter: 'agTextColumnFilter',
        headerTooltip: 'Total Cost includes Fuel Surcharge and Accessorials Cost',
        valueFormatter: this.shipmentReviewService.formatNumber

      },
      {
        headerName: 'Weight',
        width: 90,
        field: 'weight',
        filter: 'agTextColumnFilter'
      },
      {
        headerName: 'Miles',
        width: 90,
        field: 'miles',
        filter: 'agTextColumnFilter'
      },
      {
        headerName: 'OTO',
        field: 'oneTimeOnly',
        width: 80,
        filter: 'agTextColumnFilter',
      },
      {
        headerName: 'Required Move Date',
        field: 'moveDate',
        width: 120,
        filter: 'agTextColumnFilter'
      },
      {
        headerName: 'Actual Move Date',
        field: 'actualPickupDate',
        width: 120,
        filter: 'agTextColumnFilter'
      },
      {
        headerName: 'On time Pickup',
        field: 'onTimePickup',
        width: 80,
        filter: 'agTextColumnFilter'
      },
      {
        headerName: 'Pickup Exception',
        field: 'pickupException',
        width: 120,
        filter: 'agTextColumnFilter'
      },
      {
        headerName: 'Required Delivery Date',
        field: 'reqDeliveryDate',
        width: 120,
        filter: 'agTextColumnFilter'
      },
      {
        headerName: 'Actual Delivery Date',
        field: 'actualDeliveryDate',
        width: 120,
        filter: 'agTextColumnFilter'
      },
      {
        headerName: 'On time Delivery',
        field: 'onTimeDelivery',
        width: 100,
        filter: 'agTextColumnFilter'
      },
      {
        headerName: 'Delivery Exception',
        field: 'deliveryException',
        width: 100,
        filter: 'agTextColumnFilter'
      },
      {
        headerName: 'Sent To Syncada',
        field: 'sentToSyncada',
        width: 100,
        filter: 'agTextColumnFilter'
      },
      {
        headerName: 'Date Sent to Syncada',
        field: 'dateSentToSyncada',
        width: 120,
        filter: 'agDateColumnFilter'
      }

  ];
  

  getRowHeight(params) {
    return 35;
  }

  constructor(
    private shipmentDetailService: HhgOnlineBookShipmentService,
    private shipmentReviewService: ShipmentReviewService,
    private userService: UserService,
    private userPreferencesService: UserPreferencesService,
    private fb: UntypedFormBuilder,
    private alertService: AlertService,
    private router: Router,
    public datePipe: DatePipe,
    private loader: LoadingService
  ) {
    this.overlayNoRowsTemplate = '<span style="margin-top: 90px;">No results found. Please adjust your filters.</span>';
  }

  ngOnInit() {
    this.userService.getCurrentUserObservable().pipe(takeWhile(() => this.observer$.value)).subscribe(currentUser => {
      this.currentUser = currentUser;

      if (AppConstants.isNotNullCondition(this.currentUser)) {
        if (this.currentUser.roles[0].name === this.agency_admin || this.currentUser.roles[0].name === this.agency_user) {
          this.orgId = this.currentUser.organizationId;
        } else {
          this.orgId = -1;
        }
      } else {
        this.orgId = -1;
      }
      if (this.currentUser.carrierId !== null) {
        this.carrierUser = true;
        this.carrierId = this.currentUser.carrierId;
      } else {
        this.carrierUser = false;
        this.carrierId = -1;
      }
      this.getFrtShipmentPod();
      // this.recent = true;
    });
  }

  private initializeGridOptions() {
    return <GridOptions>{
      rowSelection: 'multiple',
      defaultColDef: {
        sortable: true,
        resizable: true,
        filter: 'agTextColumnFilter',
        filterParams: {
          suppressAndOrCondition: true
        }
      },
      pagination: true,
      paginationPageSize: 25,
      cacheBlockSize: 25,
      rowHeight: 45,
      headerHeight: 80,
      rowData: this.onTimeReports,
      autoSizeStrategy: {
        type: "fitGridWidth",
        defaultMinWidth: 100,
        columnLimits: [
          {
            colId: "country",
            minWidth: 900,
          },
        ],
      },
      overlayLoadingTemplate:
        '<span class="ag-overlay-loading-center">Please wait while your rows are loading</span>'
    };
  }

  onGridReady(params: any) {
    params.api.sizeColumnsToFit();
    this.gridApi = params.api;
    this.gridApi.setDatasource(this.rowData);
    params.api.sizeColumnsToFit();
  }

  loadingYears() {
    this.currentYear = new Date().getFullYear();
    this.frtShipmentPodFormGroup.get('reportingYrSelect').setValue(this.currentYear);
    this.years.push({name: this.currentYear, value: this.currentYear});
    for (let i = 1; i < 4; i++) {
      const previousYr = this.currentYear - i;
      this.years.push({name: previousYr, value: previousYr});
    }
    this.getFrtShipmentPod();
  }

  getFrtShipmentPod(){
    this.loader.show();
   this.shipmentReviewService.getShipmentPodShipmentType('All', this.orgId, this.carrierId ).subscribe(res => {
      console.log ("res.length "+ res.length);
      if (res.length > 0) {
        this.rowData = res;
        this.loader.hide();
      }else{
        this.rowData =null;
        this.loader.hide();
      }
      if (res) {
        this.shipmentReviewListBeforeEditFields = res;
        this.shipmentReviewList = res;
        //this.tmssloader.hide();
        for (const shipmentReviewDetails of this.shipmentReviewListBeforeEditFields) {
          if (shipmentReviewDetails.originCountry === 'UNITED STATES') {
            shipmentReviewDetails.origin = shipmentReviewDetails.originCity + ', '
              + shipmentReviewDetails.originState + '(' + shipmentReviewDetails.originZip + ')';
          }
          if (shipmentReviewDetails.originCountry !== 'UNITED STATES') {
            shipmentReviewDetails.origin = shipmentReviewDetails.originCountry;
          }
          if (shipmentReviewDetails.destContry === 'UNITED STATES') {
            shipmentReviewDetails.destination = shipmentReviewDetails.destCity + ', '
              + shipmentReviewDetails.destState + '(' + shipmentReviewDetails.destZip + ')';
          }
          if (shipmentReviewDetails.destContry !== 'UNITED STATES') {
            shipmentReviewDetails.destination = shipmentReviewDetails.destContry;
          }
          if (null != shipmentReviewDetails.moveDate && shipmentReviewDetails.moveDate.length > 0) {
            shipmentReviewDetails.moveDate = this.datePipe.transform(shipmentReviewDetails.moveDate, 'MM/dd/yyyy');
          }
          if (null != shipmentReviewDetails.actualDeliveryDate && shipmentReviewDetails.actualDeliveryDate.length > 0) {
            shipmentReviewDetails.actualDeliveryDate = this.datePipe.transform(shipmentReviewDetails.actualDeliveryDate, 'MM/dd/yyyy');
          }
          if (null != shipmentReviewDetails.dateSentToSyncada && shipmentReviewDetails.dateSentToSyncada.length > 0) {
            shipmentReviewDetails.dateSentToSyncada = this.datePipe.transform(shipmentReviewDetails.dateSentToSyncada, 'MM/dd/yyyy');
          }
          if (null != shipmentReviewDetails.actualPickupDate && shipmentReviewDetails.actualPickupDate.length > 0) {
            shipmentReviewDetails.actualPickupDate = this.datePipe.transform(shipmentReviewDetails.actualPickupDate, 'MM/dd/yyyy');
          }
          if (null != shipmentReviewDetails.reqDeliveryDate && shipmentReviewDetails.reqDeliveryDate.length > 0) {
            shipmentReviewDetails.reqDeliveryDate = this.datePipe.transform(shipmentReviewDetails.reqDeliveryDate, 'MM/dd/yyyy');
          }

        }
        // if (this.shipmentReviewListBeforeEditFields.length > 0) {
        //   this.haveRecords = true;
        //   this.errorMessage = '';
        // }
        // if (this.shipmentReviewListBeforeEditFields.length === 0) {
        //   this.errorMessage = 'No records found for the search criteria!!!!!! ';
        // }
      }
    }, error => {
     this.loader.hide();
     this.alertService.error('Error while getting report. Please contact system administrator.');
   });
  }

  onShipmentIdClicked(shipmentReviewListSelectedItem: any) {
    this.router.navigate(['/', 'shipmentcontrolreview'],
      {queryParams: {bookshipmentid: shipmentReviewListSelectedItem.shipmentId, shipmentType: 'FRT'}});
  }

  checkUserRole(roles?) {
    if (this.currentUser) {
      const userRoles = _.map(this.currentUser.roles, x => x.role);
      if (userRoles && userRoles.length > 0) {
        return _.includes(userRoles, roles);
      }
    }
  }

}
